import { render, staticRenderFns } from "./customerServiceConfiguration.vue?vue&type=template&id=03e95d96&scoped=true"
import script from "./customerServiceConfiguration.vue?vue&type=script&lang=js"
export * from "./customerServiceConfiguration.vue?vue&type=script&lang=js"
import style0 from "./customerServiceConfiguration.vue?vue&type=style&index=0&id=03e95d96&prod&lang=scss"
import style1 from "./customerServiceConfiguration.vue?vue&type=style&index=1&id=03e95d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e95d96",
  null
  
)

export default component.exports